import ActionTypes from 'app/action-types';
import im from 'immutable';
import { getUserFromLocalStorage, setUserInLocalStorage } from './helpers/local-storage';

function createIdentity(
  user = {
    userId: null,
    expires: null,
    token: null,
    isAuth0: null,
  }
) {
  return new im.Map({
    pending: false,
    error: null,
    ...user,
  });
}

export default (state = createIdentity(getUserFromLocalStorage()), action) => {
  switch (action.type) {
    case ActionTypes.USER_LOGIN_BEGIN:
      return state.merge({
        pending: true,
        error: null,
      });

    case ActionTypes.USER_CREATE_SUCCESS:
    case ActionTypes.USER_LOGIN_SUCCESS:
    case ActionTypes.USER_VERIFY_SUCCESS: {
      const { userId, expires, token, isAuth0 } = action.result;

      setUserInLocalStorage({ userId, expires, token, isAuth0 });

      return state.merge({
        pending: false,
        error: null,
        userId,
        expires,
        token,
        isAuth0,
      });
    }

    case ActionTypes.USER_LOGIN_FAIL:
      return state.merge({ pending: false, error: action.error });

    case ActionTypes.USER_LOGOUT:
      return createIdentity();

    default:
      return state;
  }
};
